import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase/firebaseConfig";

/**
 * Uploads an image to Firebase Storage and returns the download URL.
 * @param {File} file - The file to upload.
 * @returns {Promise<string>} - The download URL of the uploaded image.
 */
export const uploadImage = async (file) => {
    if (!file) return null;

    // Create a unique filename
    const fileName = `${Date.now()}_${file.name}`;
    const storageRef = ref(storage, `profile/${fileName}`);

    try {
        const snapshot = await uploadBytes(storageRef, file);
        const downloadURL = await getDownloadURL(snapshot.ref);
        return downloadURL;
    } catch (error) {
        console.error("Error uploading image to Firebase:", error);
        throw new Error("Failed to upload image. Please try again.");
    }
};

/**
 * Uploads a study material file (PDF/doc/etc.) to Firebase Storage.
 * @param {File} file
 * @returns {Promise<string>} download URL
 */
export const uploadStudyMaterial = async (file) => {
    if (!file) return null;

    const safeName = String(file.name || "file").replace(/\s+/g, "_");
    const fileName = `${Date.now()}_${safeName}`;
    const storageRef = ref(storage, `study-materials/${fileName}`);

    try {
        const snapshot = await uploadBytes(storageRef, file);
        return await getDownloadURL(snapshot.ref);
    } catch (error) {
        console.error("Error uploading study material to Firebase:", error);
        throw new Error("Failed to upload file. Please try again.");
    }
};
